module.exports = __webpack_public_path__ + "static/media/banner-list-seri.6493cadf.jpg";